export default __webpack_public_path__ + "static/media/IconBackArrow.067b12be.svg";